import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = {
  '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 },
};

const PartnerKpis = ({ setPartnerKpi }) => {
  const [rows, setRows] = useState([]);

  const { mutate: fetchData } = useMutation(client.creators.listKPI, {
    onSuccess: (data) => {
      /* KPI card progress */
      const total = Object.values(data).reduce((s, r) => s + r.total_partner, 0);
      setPartnerKpi({ progress: total });

      /* store rows sorted by recency */
      const sorted = Object.entries(data).sort(
        (a, b) => new Date(b[0]) - new Date(a[0])
      );
      setRows(sorted);
    },
  });

  useEffect(fetchData, []);

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>Creators</TableCell>
              <TableCell>Emails</TableCell>
              <TableCell>Partners Added</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography>No data available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map(([date, d]) => (
                <TableRow key={date}>
                  <TableCell>{date}</TableCell>
                  <TableCell>{d.creators?.join(', ') || 'N/A'}</TableCell>
                  <TableCell>{d.emails?.join(', ') || 'N/A'}</TableCell>
                  <TableCell>{d.total_partner}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PartnerKpis;
